import { sha1 } from '@noble/hashes/legacy.js';
import { sha256 } from '@noble/hashes/sha2.js';
import { bytesToHex } from '@noble/hashes/utils.js';

import { decodeUTF8 } from './utils';

export function hashSha1Hex(input: string): string {
  return bytesToHex(sha1(decodeUTF8(input)));
}

export function hashSha256(input: Uint8Array): Uint8Array<ArrayBuffer> {
  return sha256(input);
}
